// The built-in questionnaire playbooks, by the name they are seeded under in the
// global account (ntrced/scripts/migration). The app finds and launches them by
// name.
export const ANSWER_QUESTIONNAIRE_PLAYBOOK_NAME = 'Answer Questionnaire'
export const PREFILL_VENDOR_QUESTIONNAIRE_PLAYBOOK_NAME =
  'Pre-fill a Vendor Questionnaire'
export const EVALUATE_QUESTIONNAIRE_PLAYBOOK_NAME =
  'Evaluate Questionnaire Answers'
